import {
  TizenPaletteDisplayOption,
  TizenPaletteMotionDetector,
  TizenPaletteMotionSleepTime,
  TizenPaletteNightMode,
  TizenPaletteRotationTime,
} from '../platforms/tizen-types'

export interface HTVConfig {
  enableDebug: boolean
  useNativeVolumeDisplay: boolean
  googlecast?: GoogleCastConfig
  netflix?: NetflixConfig
  vod?: VODConfig
  autoReboot?: AutoRebootConfig
  tizenConfig?: TizenConfig
  webosConfig?: WebOSConfig
}

export interface GoogleCastConfig {
  enabled: boolean
  type: GoogleCastType
  hdmiPort?: number
  integratedMode: GoogleCastIntegratedMode
  proxyServerType: GoogleCastProxyServerType
  proxyStatusEndpoint?: string
  proxyPage: GoogleCastProxyPage
  proxyRemoteEndpoint?: string
}

export enum GoogleCastType {
  DONGLE = 'DONGLE',
  INTEGRATED = 'INTEGRATED',
}

export enum GoogleCastIntegratedMode {
  PROXY = 'PROXY',
  SOFT_AP = 'SOFT_AP',
}

export enum GoogleCastProxyServerType {
  IQCAST = 'IQCAST',
  VDCAST = 'VDCAST',
}

export enum GoogleCastProxyPage {
  LOCAL = 'LOCAL',
  REMOTE = 'REMOTE',
}

export interface NetflixConfig {
  enabled: boolean
  hotelId?: string
  token?: string
  appId?: string
  appName?: string
}

export interface VODConfig {
  enabled: boolean
  catalogUrl?: string
}

export interface AutoRebootConfig {
  enabled: boolean
  localHour: number
  localMinute: number
}

export interface TizenConfig {
  paletteConfig?: TizenPaletteConfig
}

export interface TizenPaletteConfig {
  enabled: boolean
  playMode: TizenPaletteConfigPlayMode
  scheduling: {
    enabled: boolean
    onTime: string
    offTime: string
  }
  mediaIds: string[]
  options: {
    rotationTime: TizenPaletteRotationTime
    displayOption: TizenPaletteDisplayOption
    nightMode: TizenPaletteNightMode
    motionSleepTime: TizenPaletteMotionSleepTime
    motionDetector: TizenPaletteMotionDetector
  }
}

export enum TizenPaletteConfigPlayMode {
  GEN_WALLPAPER = 'GEN_WALLPAPER',
  EXTERNAL = 'EXTERNAL',
}

export interface WebOSConfig {
  instantOn?: WebOSInstantOn
}

export enum WebOSInstantOn {
  OFF = 'OFF',
  INSTANT_MUTE = 'INSTANT_MUTE',
  INSTANT_REBOOT = 'INSTANT_REBOOT',
}
